/* eslint-disable */
import _ from 'underscore';
function from(params, from_version) {
  delete params.$format;
  if (params.$inlinecount) {
    delete params.$inlinecount;
    params.$count = true;
  }
  if (!(_.isString(params.$filter) && params.$filter.length)) {
    delete params.$filter;
  }
  if (params.$filter) {
    params.$filter = params.$filter.replace(/substringof\(('.*?'),(tolower\([\w\/]+?\))\)/g, 'contains($2, $1)');
    params.$filter = params.$filter.replace(/substringof\(('.*?'),([\w\/]+?)\)/g, 'contains($2, $1)');
    params.$filter = params.$filter.replace(/'Enum\.(\w+)''((\w+,?)+)'''/g, 'Enum.$1\'$2\'');
    params.$filter = params.$filter.replace(/datetime'(.*?)'/g, '$1+00:00');
  }
  return params;
}
export default {
  from: from
};

